// brandsActions.js

export const GET_BRANDS = 'GET_BRANDS';
export const RESERVE_BRAND = 'RESERVE_BRAND';
